import PropTypes from 'prop-types';

export const JobSchema = PropTypes.shape({
  applicationMethod: PropTypes.string.isRequired,
  applicationPath: PropTypes.string,
  compensationMin: PropTypes.number,
  compensationMax: PropTypes.number,
  compensationCurrency: PropTypes.string,
  compensationPeriod: PropTypes.string,
  compensationPublic: PropTypes.bool.isRequired,
  description: PropTypes.string,
  discarded: PropTypes.bool.isRequired,
  expiresAt: PropTypes.string,
  id: PropTypes.number.isRequired,
  liked: PropTypes.bool,
  postedAt: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  deactivatedAt: PropTypes.string,
  closedAt: PropTypes.string,
  passesFilter: PropTypes.bool.isRequired,
  visibility: PropTypes.string.isRequired,
  employmentTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  organization: PropTypes.shape({
    id: PropTypes.number.isRequired,
    domain: PropTypes.string,
    name: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      placeId: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  ),
});
